import Backbone from 'backbone';
import { EmptyObject } from '@ve/types/EmptyObject';
import { directFlights, DirectFlight } from './directFlights';
import { block, BlockParams } from './block';

export default (tourCriteria: Backbone.Model): DirectFlight | BlockParams | EmptyObject => ({
        ...directFlights(tourCriteria),
        ...block(tourCriteria),
});